import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
};

export default function RejectDocumentDialog({
  open,
  loading = false,
  onClose,
  onConfirm,
}: Props) {
  const [comment, setComment] = useState("");
  const { t } = useAppTranslation("common");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("Odrzuć dokument")}</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          label={t("Powód odrzucenia")}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          disabled={loading}
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("Anuluj")}
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={loading || !comment.trim()}
          onClick={() => onConfirm(comment)}
        >
          {t("Odrzuć")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
